import { render, staticRenderFns } from "./ChangeOrg.vue?vue&type=template&id=782c7b5b&scoped=true";
import script from "./ChangeOrg.vue?vue&type=script&lang=js";
export * from "./ChangeOrg.vue?vue&type=script&lang=js";
import style0 from "./ChangeOrg.vue?vue&type=style&index=0&id=782c7b5b&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "782c7b5b", null);
export default component.exports;